<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'sample-proofing',
  components: {
    PageTable,
  },
}
</script>
